import WhatsAppTriggerNodeSettings from "./WhatsAppTriggerNode";
import SmsTriggerNodeSettings from "./SmsTriggerNode";

export const TRIGGER_NODE_SETTINGS = {
  whatsapp: (props) => <WhatsAppTriggerNodeSettings {...props} />,
  sms: (props) => <SmsTriggerNodeSettings {...props} />,
};
